import React, {ReactElement} from "react"
import {Navigate} from "react-router-dom"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import IncomingRtp from "../../components/IncomingRtp/IncomingRtp"
import {useIsUnitUser} from "../../services/auth"
import {IncomingRtpColumns} from "../../components/IncomingRtp/IncomingRtp.types"

export default function IncomingRtpPage(): ReactElement {
	const isUnitUser = useIsUnitUser()

	if (!isUnitUser) {
		return <Navigate to="/" replace />
	}

	return (
		<>
			<TitleBar title={"Incoming RTP"} />

			<MainSectionTable>
				<IncomingRtp
					includedColumns={[
						IncomingRtpColumns.id,
						IncomingRtpColumns.org,
						...(isUnitUser ? [IncomingRtpColumns.bank] : []),
						IncomingRtpColumns.accountId,
						IncomingRtpColumns.customer,
						IncomingRtpColumns.amount,
						IncomingRtpColumns.status,
						IncomingRtpColumns.type,
						IncomingRtpColumns.isMonetary,
						IncomingRtpColumns.createdAt,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
